export const environment = {
  production: true,
  envBadge: null as 'develop' | 'staging' | null,
  api: 'https://api.previdas.com.br/v1',
  api_v2: 'https://api.previdas.com.br',
  enableIdpLogin: false,
  idpApiUrl: null as string | null,
  stableUrl: 'https://app.previdas.com.br/#/login',
  stableUrlIndication: 'https://app.previdas.com.br/#/indications',
  appVersion: require('../../package.json').version + '-dev',
  sentry: null,
  iuguId: 'B15FC93661374C09884C66CDBEADC18A',
  intercom: 'mcudk4rm',
  communicareApiAgendaOnline:
    'https://api-agenda-online-production.communicare.com.br/v1',
  communicareAccountId: 1205,
  communicareDefaultOccupationId: 15,
  communicareDefaultClinicId: 1143,
  communicareHealthPlanId: 261,
  asaasInvoiceLink: 'https://asaas.com/customerInvoice/show/',
};
